import { Component, Inject, inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
} from "@angular/material/dialog";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormArray,
  ReactiveFormsModule,
} from "@angular/forms";
import { AsyncPipe, NgIf, NgFor } from "@angular/common";
import { UsersService, RegistrationPrefill } from "src/app/api/users.service";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import {
  MatFormFieldModule,
  MatFormField,
  MatLabel,
} from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { MatButtonModule } from "@angular/material/button";
import { LoaderService } from "src/app/core/Loader.services";
import {
  atLeastOneSelected,
  emailDuplicateValidator,
} from "./registration.validators";
import {
  CompanyDto,
  PagedResult,
  ApproverDto,
  ExternalUserRegistration,
  AppOption,
  ApiResponse,
} from "src/app/shared/models/registration.models";
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";

import {
  Observable,
  Subject,
  BehaviorSubject,
  combineLatest,
  of,
  firstValueFrom,
} from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  map,
  startWith,
} from "rxjs/operators";
import { MatListModule } from "@angular/material/list";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { LogsModel, SessionLogsModel } from "src/app//shared/models/log.model";
//import { ApiResponse } from "src/app/shared/common/api-response.model";

export interface UserRegistrationDialogData {
  prefill: RegistrationPrefill;
}

@Component({
  selector: "app-external-user-registration",
  templateUrl: "./external-user-registration.component.html",
  //styleUrls: ['./external-user-registration.component.css'], // Note: Changed 'styleUrl' to 'styleUrls'
  imports: [
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatInputModule,
    MatSnackBarModule,
  ],
})
export class ExternalUserRegistrationComponent implements OnInit {
  private fb = inject(FormBuilder);
  private users = inject(UsersService);
  private loader = inject(LoaderService);
  private dialogRef = inject(MatDialogRef<ExternalUserRegistrationComponent>);
  private gbService = inject(GlobalServiceService);
  private snack = inject(MatSnackBar);
  Math = Math;
  isMobile = this.gbService.isMobile;
  // private fb: FormBuilder;
  // private users: UsersService;
  // private loader: LoaderService;
  //dialogRef: MatDialogRef<ExternalUserRegistrationComponent>;
  public saving = false;
  loading = true;

  userType: "Internal" | "External" = "External";
  currentUserId = 0;
  myCompanyId = 0;
  isInternal = false;
  isExternal = false;
  lockToMyCompany = false;
  //stricterEmailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  stricterEmailRegex =/^[A-Za-z0-9._%+\-]+@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?)\.)+[A-Za-z]{2,}$/
  //data: Inject(UserRegistrationDialogData);

  // constructor() {
  //   this.fb = inject(FormBuilder);
  //   this.users = inject(UsersService);
  //   this.dialogRef = inject(MatDialogRef<ExternalUserRegistrationComponent>);
  //   this.data = inject<UserRegistrationDialogData>(MAT_DIALOG_DATA);
  //   this.loader = inject(LoaderService);

  // }
  form = this.fb.group({
    companyId: ["", [Validators.required]],
    firstName: ["", [Validators.required, Validators.maxLength(30)]],
    lastName: ["", [Validators.required, Validators.maxLength(30)]],
    email: [
      "",
      {
        validators: [
          Validators.required,
          Validators.email,
          Validators.maxLength(120),
          Validators.pattern(this.stricterEmailRegex),
        ],
        asyncValidators: [emailDuplicateValidator(this.users)],
        updateOn: "blur",
      },
    ],
    appAccess: this.fb.array(
      [false, false, false, false, false].map((v) => this.fb.control(v)),
      [atLeastOneSelected()],
    ),
    approverId: ["", [Validators.required]],
    //protectedState: [''],
  });
  get appAccessFA(): FormArray {
    return this.form.get("appAccess") as FormArray;
  }

  // Common company stream
  /** Companies – common API, front‑end pagination + search */
  companyAll: CompanyDto[] = [];
  companyFiltered: CompanyDto[] = [];
  companyPageSize = 10; // show 10 per page
  companyPageIndex = 0;
  companySearchTerm = "";

  /** Approvers – load full list once; filter + virtual scroll */
  approverAll: ApproverDto[] = [];
  approverFiltered: ApproverDto[] = [];

  approverSearchTerm = "";

  approverItemSize = 56;
  //protectedSate:any;

  onApproverOptionSelected(ev: MatAutocompleteSelectedEvent) {
    const selected: ApproverDto = ev.option.value;
    // Patch the form with selected approver id (adjust the key to your form)
    this.form.patchValue({
      approverId: (selected as any).AE_User_Id ?? selected.AE_User_Id,
    });
  }

  readonly appKeys = [
    "SalesForce Deal Memo: Contract entry and amendment",
    "Tracker+: Product Development and Tracking",
    "Creative Library: Find, Download, and Share creative digital assets from our library of properties",
    "Financial Center: Royalties, payments, and financials",
    "Salesforce Forecasting: Forecast submissions and adjustment",
  ];

  readonly appOptions: AppOption[] = [
    {
      AppId: "1",
      Key: "SalesForce Deal Memo: Contract entry and amendment",
      label: "SalesForce Deal Memo",
    },
    {
      AppId: "4",
      Key: "Tracker+: Product Development and Tracking",
      label: "Tracker+",
    },
    {
      AppId: "5",
      Key: "Creative Library: Find, Download, and Share creative digital assets from our library of properties",
      label: "Creative Library",
    },
    {
      AppId: "6",
      Key: "Financial Center: Royalties, payments, and financials",
      label: "Financial Center",
    },
    {
      AppId: "7",
      Key: "Salesforce Forecasting: Forecast submissions and adjustment",
      label: "Salesforce Forecasting",
    },
  ];

  // Holds the list to render (derived)
  visibleAppOptions: AppOption[] = [...this.appOptions];

  // Map for quick id → index in master
  private appIndexById = new Map<string, number>(
    this.appOptions.map((opt, i) => [opt.AppId, i]),
  );

  async ngOnInit() {
    try {
      this.loader.show();

      const profile = await this.users.ensureHydrated();
      this.userType = profile?.["user-type"] ? "Internal" : "External";
      this.myCompanyId = profile?.["company-id"] ?? 0;
      this.isInternal = this.userType === "Internal";
      this.isExternal = this.userType === "External";
      this.lockToMyCompany = this.isExternal;
      this.currentUserId = profile?.["user-id"] ?? 0;

      this.form.patchValue({
        //email: profile?.['email-id'] ?? '',
        //firstName: profile?.['first-name'] ?? '',
        //lastName: profile?.['last-name'] ?? ''
      });

      // 2) Companies: common API (returns a large list for internal, small for external)
      //   Make sure UsersService has: getCompaniesByEmail(email: string): Observable<CompanyDto[]>
      // this.users.getExternalUserFormSeed().subscribe({
      //   next: (res) => {
      //     this.form.patchValue({
      //       protectedState: res
      //     })
      //   }
      // });

      const companies: CompanyDto[] = await firstValueFrom(
        this.users.getCompaniesByEmail(this.users.getUserEmailFromSession()),
      );
      //const companiesres = await firstValueFrom(this.users.getCompaniesByEmail(this.users.getUserEmailFromSession()));
      //const companies: CompanyDto[] = companiesres['data'] ?? [];
      this.companyAll = companies ?? [];
      this.applyCompanyFilter(""); // initialize filtered + first page

      // External: lock to user's company (even if list contains more)
      if (this.lockToMyCompany) {
        // Ensure user's company is present in list; if not, append a display fallback
        //  const found = this.companyAll.find(c => c.Account_Id === this.myCompanyId);
        //  if (!found && this.myCompanyId) {
        //    this.companyAll = [{ Account_Id: this.myCompanyId, Account_Name: 'My Company',Account_Type:'Licensee',Category:'Internal' }, ...this.companyAll];
        //    this.applyCompanyFilter(this.companySearchTerm);
        //  }
        this.form.patchValue({ companyId: this.myCompanyId.toString() });
        this.refreshVisibleAppsForCompany(
          this.companyAll.find((c) => c.Account_Id === this.myCompanyId),
        );
        //this.form.get('companyId')?.disable();
      }

      // 3) Approvers: load full list once (use your "get all" endpoint if available)
      // If you only have search with paging, request a very large pageSize once.
      const allApprovers: ApproverDto[] = await firstValueFrom(
        this.users.searchApprovers("", 1, 100000),
      );

      //  const allApprovers: PagedResult<ApproverDto> =
      //    await firstValueFrom(this.users.searchApprovers('', 1, 100000));
      //this.approverAll = allApprovers ?? [];
      //this.applyApproverFilter(''); // initialize filtered for virtual scroll
      // 3) Approvers: load full list once (ApiResponse wrapper)
      //type ApiResponse<T> = { status: string; message?: string; data: T };

      try {
        // Form PagedResult<ApproverDto> from flat array
        const approverPaged: PagedResult<ApproverDto> = {
          items: allApprovers,
          page: 1,
          pageSize: allApprovers.length, // or your desired pageSize (e.g., 10)
          total: allApprovers.length,
        };

        // If you want client-side pagination with pageSize=10 (recommended):
        const pageSize = 10;
        const pageIndex = 0; // start at first page

        const pageItems = allApprovers.slice(
          pageIndex * pageSize,
          (pageIndex + 1) * pageSize,
        );

        const approverPagedClient: PagedResult<ApproverDto> = {
          items: pageItems,
          page: pageIndex + 1,
          pageSize,
          total: allApprovers.length,
        };

        this.approverAll = allApprovers;
        this.applyApproverFilter(""); // initialize filtered for virtual scroll
      } catch (e) {
        console.error(e);
        this.approverAll = [];
        this.applyApproverFilter("");
      }
    } finally {
      this.loading = false;
      this.loader.hide();
    }
  }

  /** --- Companies: Search & paging (frontend) --- */
  onCompanySearchInput(term: string) {
    this.applyCompanyFilter(term);
  }
  displayApprover(a: ApproverDto | null): string {
    return a ? (a.AE_Name ?? a.Username ?? "") : "";
  }
  // (optional) reset search when panel opens
  onApproverPanelOpened(): void {
    // Reset search or keep last term—choose one behavior
    // this.applyApproverFilter('');
  }

  // Apply search filter to companies and make result arrange alphabetically
  private applyCompanyFilter(term: string) {
    this.companySearchTerm = (term || "").trim().toLowerCase();
    this.companyFiltered = this.companyAll
      .filter((c) =>
        (c.Account_Name || "").toLowerCase().includes(this.companySearchTerm),
      )
      .sort((a, b) =>
        (a.Account_Name || "").localeCompare(b.Account_Name || ""),
      );
    // this.companyFiltered = this.companyAll.filter(c =>
    //   (c.Account_Name || '').toLowerCase().includes(this.companySearchTerm)
    // );
    this.companyPageIndex = 0; // reset page
  }

  get companiesPage(): CompanyDto[] {
    const start = this.companyPageIndex * this.companyPageSize;
    const end = start + this.companyPageSize;
    return this.companyFiltered.slice(start, end);
  }

  prevCompanyPage() {
    if (this.companyPageIndex > 0) this.companyPageIndex--;
  }
  nextCompanyPage() {
    const maxPageIndex = Math.max(
      0,
      Math.ceil(this.companyFiltered.length / this.companyPageSize) - 1,
    );
    if (this.companyPageIndex < maxPageIndex) this.companyPageIndex++;
  }

  onCompanySelected(c: CompanyDto) {
    //check if external user has selected company which are only available to them

    const foundCompany = this.companyAll.find(
      (company) => company.Account_Id === c.Account_Id,
    );
    if (this.lockToMyCompany && !foundCompany) return;
    //this.form.patchValue({ companyId: c.Account_Id });
    // Patch the selected company id into form
    this.form.patchValue({ companyId: c.Account_Id.toString() ?? "" });

    // :repeat: Re-filter visible apps per company/type
    this.refreshVisibleAppsForCompany(c);
  }

  /** --- Approvers: Search (frontend) + virtual scroll --- */
  onApproverSearch(term: string) {
    this.applyApproverFilter(term);
  }

  private applyApproverFilter(term: string) {
    this.approverSearchTerm = (term || "").trim().toLowerCase();
    this.approverFiltered = this.approverAll.filter((a) => {
      const dn = (a.AE_Name || "").toLowerCase();
      const em = (a.Username || "").toLowerCase();
      return (
        dn.includes(this.approverSearchTerm) ||
        em.includes(this.approverSearchTerm)
      );
    });
  }
  displayCompany = (c: CompanyDto | null): string =>
    c ? (c.Account_Name ?? "") : "";

  onApproverSelected(a: ApproverDto) {
    this.form.patchValue({ approverId: a.AE_User_Id });
  }

  appCheckedChanged(i: number, checked: boolean) {
    this.appAccessFA.at(i).setValue(checked);
    this.appAccessFA.updateValueAndValidity();
  }

  // private getSelectedAppIds(): string[] {
  //   return this.appAccessFA.controls
  //     .map(c => c.value as { AppId?: string; selected?: boolean })
  //     .filter(v => !!v?.selected && !!v?.AppId)
  //     .map(v => v.AppId!);
  //  }
  private getSelectedAppIds(): string[] {
    // Guard against length mismatches
    const max = Math.min(
      this.visibleAppOptions.length,
      this.appAccessFA.length,
    );

    const selected: string[] = [];
    for (let i = 0; i < max; i++) {
      const ctrl = this.appAccessFA.at(i);
      const checked = !!ctrl?.value; // ensure boolean
      if (checked) {
        selected.push(this.visibleAppOptions[i].AppId);
      }
    }
    return selected;
  }
  // private getSelectedAppIds(): string[] {
  //   // Map each checked index to its corresponding option.id
  //   return this.appOptions
  //     .map((opt, i) => ({ id: opt.AppId, checked: !!this.appAccessFA.at(i).value }))
  //     .filter(x => x.checked)
  //     .map(x => x.id);
  //  }

  async onSave() {
    const emailCtrl = this.form.get("email");
    emailCtrl?.markAsTouched();
    emailCtrl?.updateValueAndValidity({ onlySelf: true, emitEvent: true });

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const selectedApps = this.getSelectedAppIds();

    const companyId = this.form.getRawValue().companyId;

    const payload: ExternalUserRegistration = {
      account_Id: Number(companyId),
      user_Id: this.currentUserId,
      first_Name: this.form.value.firstName!,
      last_Name: this.form.value.lastName!,
      email_Address: this.form.getRawValue().email!,
      account_Name:
        this.companyAll.find((c) => c.Account_Id === Number(companyId))
          ?.Account_Name || "",
      application_Id: selectedApps.join(","),
      aeMapId: Number(this.form.value.approverId!),
      // AE_email:
      //   this.approverAll.find(
      //     (a) => a.AE_User_Id === this.form.value.approverId,
      //   )?.Username || "",
      ProtectedState: crypto.randomUUID(), //read hidden field value
    };

    // 6) Call service with loader and message handling
    this.loader.show();
    this.loading = true;
    try {
      /**
       * A) If saveRegistration UNWRAPS ApiResponse IN THE SERVICE and returns plain data:
       *   const data = await firstValueFrom(this.users.saveRegistration(payload));
       *   this.snack.open('Registration completed successfully.', 'Close', { duration: 4000 });
       *   this.dialogRef.close({ saved: true, data });
       *
       * B) If saveRegistration returns ApiResponse and you unwrap HERE:
       */
      const res: ApiResponse<string> = await firstValueFrom(
        this.users.saveRegistration(payload) as any,
      );

      if (!res || res.status === false) {
        const msg = res?.message ?? "Registration failed.";
        this.snack.open(msg, "Dismiss", { duration: 6000 });
        return; // Keep dialog open so user can correct input
      }

      // Success
      const successMsg = "Registration completed successfully.";
      //log this as user activity
      const logModal: LogsModel = {
        category: "Logs",
        correlationId: "",
        eventId: "External User Registration",
        ipAddress: "",
        message: `User submitted  external user request ${this.companyAll.find((c) => c.Account_Id === Number(companyId))?.Account_Name || ""}`,
        payloadJson: `data: ${JSON.stringify(payload)}`,
        source: "HomePage",
        stackTrace: "",
        userId: this.currentUserId?.toString() ?? "",
      } as LogsModel;
      this.snack.open(successMsg, "Close", { duration: 4000 });
      this.dialogRef.close({ saved: true, message: successMsg });
    } catch (err: any) {
      const msg =
        err.error?.message ?? err?.message ?? "Failed to save registration.";
      this.snack.open(msg, "Dismiss", { duration: 6000 });
      // Keep dialog open so user can adjust
    } finally {
      this.loading = false;
      this.loader.hide();
    }
  }

  onCancel() {
    this.dialogRef.close({ saved: false });
  }

  // Helper: (re)compute visible apps based on selected company/type
  private refreshVisibleAppsForCompany(company: any) {
    // 0) Snapshot current visible + selections (FormArray aligned to visible indices)
    const prevVisible = this.visibleAppOptions;
    const prevSelectionsById = new Map<string, boolean>();
    prevVisible.forEach((opt, i) => {
      const ctrl = this.appAccessFA.at(i);
      prevSelectionsById.set(opt.AppId, !!ctrl?.value);
    });
    // 1) Decide which app(s) to hide (rule engine).
    // Example rule:
    // - If company is "External" type, hide App E.
    // - If company is "Internal" type, show all.
    const isExternalAgencyCompany =
      (company?.Company_Type ?? company?.Account_Type ?? "").toLowerCase() ===
      "agent";

    const hideIds = new Set<string>();
    if (!isExternalAgencyCompany) {
      hideIds.add("1"); // App 1 hidden for agency companies
    } else {
      hideIds.delete("1");
    }

    // 2) Recompute visible list
    this.visibleAppOptions = this.appOptions.filter(
      (opt) => !hideIds.has(opt.AppId),
    );
    // 3) Rebuild the FormArray to match the new visible list,
    //   carrying over selection *by AppId* so nothing "slides" to the next item
    const newControls = this.visibleAppOptions.map((opt) => {
      const wasSelected = prevSelectionsById.get(opt.AppId) ?? false;
      return this.fb.control(wasSelected);
    });

    // Replace controls in-place
    this.appAccessFA.clear();
    newControls.forEach((c) => this.appAccessFA.push(c));

    // 3) If any hidden app was selected, clear its checkbox in FormArray commpute based on appid
    // hideIds.forEach(id => {
    //   const idx = this.appOptions.findIndex(opt => opt.AppId === id);
    //   if(idx===-1) return;
    //   //const appControl = this.appAccessFA.controls.find((control, i) => this.appOptions[i].AppId === id);
    //   const appControl=this.appAccessFA.at(idx);
    //   const masterappControl = this.appOptions.at(idx)?.AppId;
    //   if (masterappControl===id && appControl?.value) {
    //     appControl.setValue(false,{emitEvent:false});
    //   }

    // });

    // 4) Revalidate after changes
    //this.appAccessFA.updateValueAndValidity();
  }
  get emailTakenInfo(): { exists: boolean; message?: string } | null {
    const err = this.form.get("email")?.getError("emailTaken");
    return err ? { exists: !!err.exists, message: err.message } : null;
  }
}
